import { apiClient } from "../../utils/apiClient";
import { Role } from "../../types/roles";

export const fetchRoles = (): Promise<Role[]> => {
  return apiClient.get("/roles").then((response) => response.data);
};

export const getRoleByName = (roleName: string): Promise<Role> => {
  return apiClient.get(`/roles/name/${roleName}`).then((response) => response.data);
};

export const createRole = (role: Role): Promise<Role> => {
  console.warn('Role enviado al backend:', role);
  return apiClient.post("/roles", role).then((response) => response.data);
};

export const updateRole = (role: Role): Promise<Role> => {
    return apiClient.post("/roles", role).then((response) => response.data);
};

export const deleteRole = (role_id: number): Promise<void> => {
    return apiClient.delete(`/roles/${role_id}`).then((response) => response.data);
};